import { api, qs } from './client.js';

/** 서버: modules/whitelist (banana_custom.admin_whitelist). */
export interface WhitelistEntry {
  seq: number;
  ip: string;
  iptype: 1 | 2 | 3;
  isActive: boolean;
  memo: string | null;
  createdIp: string | null;
  createdAgent: string | null;
  createdAt: string | null;
  deletedIp: string | null;
  deletedAgent: string | null;
  deletedAt: string | null;
}

export type WhitelistFilter = 'N' | 'Y' | 'A';

export interface CreateWhitelistInput {
  ip: string;
  iptype: 1 | 2 | 3;
  memo: string;
  isActive?: boolean;
}

export interface UpdateWhitelistInput {
  memo?: string;
  isActive?: boolean;
}

export const whitelistApi = {
  list: (filter: WhitelistFilter, search?: string) =>
    api.get<{ entries: WhitelistEntry[] }>(`/whitelist${qs({ filter, search })}`),
  create: (input: CreateWhitelistInput) => api.post<{ entry: WhitelistEntry }>('/whitelist', input),
  update: (seq: number, input: UpdateWhitelistInput) =>
    api.patch<{ entry: WhitelistEntry }>(`/whitelist/${seq}`, input),
};
